export const API_URL = process.env.VUE_APP_API_URL;

export default {
      async createLoginPost(post) {

            const requestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(post)
            };
            
            const response = await fetch(API_URL+"api/admin/login", requestOptions);
            const postData = await response.json();

            //console.log(postData);
            return postData;

      },

      async createAccessPost(post) {
      
            const requestOptions = {
                  method: "POST",
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: post
            };
      
            return await fetch(API_URL+'account/confirmation', requestOptions);
      }

             

}